import React from 'react';

import { Grid, Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@material-ui/icons';
import { get } from 'lodash';

import { Chip, Tooltip } from 'components/v2';

import { useDialogContext, useFiltersContext } from '../FiltersDialogContext';

import FilterEmptyState from './FilterEmptySate/FilterEmptyState';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    contentWrapper: {
      padding: `0px ${unit * 3}px`,
      height: 228,
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
    helperTextIcon: {
      marginLeft: unit,
      marginRight: (-1 * unit) / 2,
    },
  });

interface FiltersSelectItemsProps extends WithStyles<typeof styles> {
  staticData?: any;
  type: string;
}

const FiltersSelectItems: React.FC<FiltersSelectItemsProps> = ({ classes, staticData, type }) => {
  const { updater, filters } = useFiltersContext();
  const { toggleLockFilters } = useDialogContext();

  const handleSelectItem = (item: any) => {
    updater(type)(item._id);
    toggleLockFilters(false);
  };

  const isSelected = (id: string) =>
    (filters[type].includes('all') && !filters[type].includes(id)) ||
    (filters[type].includes('all') && filters[type].lenth === 1) ||
    (!filters[type].includes('all') && filters[type].includes(id));

  return (
    <div className={classes.contentWrapper}>
      <Grid container spacing={8}>
        {get(staticData, 'length', 0) === 0 ? (
          <FilterEmptyState />
        ) : (
          staticData.map((item: any) => (
            <Grid item key={get(item, '_id', item.id)}>
              <Chip
                color="supportPowder"
                label={item.label}
                onClick={() => handleSelectItem(item)}
                selected={isSelected(item._id)}
                icon={
                  item.helperText && (
                    <Tooltip title={item.helperText} placement="top" hideArrow>
                      <HelpOutlineIcon className={classes.helperTextIcon} fontSize="small" />
                    </Tooltip>
                  )
                }
              />
            </Grid>
          ))
        )}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(FiltersSelectItems);
